import React, { Fragment } from 'react'
import { Table } from 'reactstrap'
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners'
import uuid from 'uuid/v1'
import { VerifyResultsRow } from './'
import { createVerifyRowData } from '../../../helpers/assessment/uploadCSV';

/**
 * Gives the errors and warnings that are the 
 * results of verifying the csv upload.
 */
function VerifyResultsTable ({
  verifyWarnings,
  verifyErrors,
  verifying,
}) {
  const style = {maxHeight: 1000, overflow: 'auto'}
  const tableData = createVerifyRowData({verifyWarnings, verifyErrors})
  if (!verifyWarnings && !verifyErrors) {
    return null
  } else {
    return (
      <Fragment>
        {!verifying 
          ? <div style={style}>
              <Table>
                <thead>
                  <tr>
                    <th>Category</th>
                    <th>Message</th>
                    <th>Rows</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map(row => 
                    <VerifyResultsRow 
                      category={row.category}
                      message={row.message}
                      rows={row.rows}
                      key={uuid()}
                    />
                  )}
                </tbody>
              </Table>
            </div>
          : <BeatLoader loading={verifying}/>
        }
      </Fragment>
    )
  }
}

VerifyResultsTable.propTypes = {
  verifyWarnings: PropTypes.object,
  verifyErrors: PropTypes.object,
  verifying: PropTypes.bool.isRequired,
}

export default VerifyResultsTable


// WEBPACK FOOTER //
// ./src/components/Assessment/UploadCSVComponents/VerifyResultsTable.js